<section class="w-full mx-auto px-10 bg-gray-200 dark:bg-gray-800 dark:text-white">
    <div class="flex flex-wrap">
        <div class="w-full px-4 mt-10">
            <div class="text-center mx-auto mb-12 max-w-2xl">
                <h2 class="font-bold text-3xl sm:text-4xl md:text-[40px] text-dark mb-4">
                    Testimonials
                </h2>
                <p class="text-base text-body-color">
                    Our customers' experiences speak for themselves! From seamless bookings to unforgettable adventures, we take pride in making every journey special. See what our happy travelers have to say about their incredible trips with us.
                </p>
            </div>
        </div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-5 gap-5 w-full">
        <fuse-card
            class="p-7 bg-white dark:bg-gray-700 drop-shadow-md col-span-2 flex flex-col gap-y-10 justify-between">
            <div class="flex flex-col gap-y-3.5">
                <p class="font-bold text-xl">Mauritius Holiday</p>
                <p class="font-medium text-slate-700/90 dark:text-gray-300">I recently booked a family vacation to Mauritius through XL Travel Group, and it was an absolute dream. The team was incredibly helpful in planning every detail, from finding the perfect accommodations to arranging exciting activities. Our kids had a blast exploring the island, and we adults enjoyed relaxing on the beach.</p>
            </div>
            <div class="flex flex-col">
                <!-- <img src="https://randomuser.me/api/portraits/women/54.jpg" alt="Jane Cooper" class="h-10 w-10"> -->
                <p class="pt-2 text-sm font-semibold">The Coopers</p>
                <!-- <p class="text-sm font-medium text-slate-700/70 dark:text-gray-400">CEO at ABC Corporation</p> -->
            </div>
        </fuse-card>
        <fuse-card
            class="p-7 bg-white dark:bg-gray-700 drop-shadow-md col-span-3 flex flex-col gap-y-10 justify-between">
            <div class="flex flex-col gap-y-3.5">
                <p class="font-bold text-xl">A Solo Experience</p>
                <p class="font-medium text-slate-700/90 dark:text-gray-300">As a solo traveler, I was initially hesitant about booking a package holiday. However, my experience with XL Travel Group was fantastic. The group was small and friendly, and the tour guide was knowledgeable and accommodating. I felt safe and comfortable throughout the trip. I highly recommend XL Travel Group for solo travelers.</p>
            </div>
            <div class="flex flex-col">
                <!-- <img src="https://randomuser.me/api/portraits/women/30.jpg" alt="John Doe" class="h-10 w-10"> -->
                <p class="pt-2 text-sm font-semibold">Emily Smith</p>
                <!-- <p class="text-sm font-medium text-slate-700/70 dark:text-gray-400">Marketing Manager at ABC Company</p> -->
            </div>
        </fuse-card>
        <fuse-card
            class="p-7 bg-white dark:bg-gray-700 drop-shadow-md col-span-3 flex flex-col gap-y-10 justify-between">
            <div class="flex flex-col gap-y-3.5">
                <p class="font-bold text-xl">A Honeymoon to remember</p>
                <p class="font-medium text-slate-700/90 dark:text-gray-300">We booked our honeymoon through XL Travel Group and it was the best decision we ever made. The attention to detail was impeccable, and the personalized service was top-notch. Our dream honeymoon became a reality thanks to XL Travel Group. We can't wait to travel with them again in the future.</p>
            </div>
            <div class="flex flex-col">
                <!-- <img src="https://randomuser.me/api/portraits/women/90.jpg" alt="Jane Doe" class="h-10 w-10"> -->
                <p class="pt-2 text-sm font-semibold">The Brown's</p>
                <!-- <p class="text-sm font-medium text-slate-700/70 dark:text-gray-400">CTO at XYZ Corporation</p> -->
            </div>
        </fuse-card>
        <fuse-card
            class="p-7 bg-white dark:bg-gray-700 drop-shadow-md col-span-2 flex flex-col gap-y-10 justify-between">
            <div class="flex flex-col gap-y-3.5">
                <p class="font-bold text-xl">Paradise in earth</p>
                <p class="font-medium text-slate-700/90 dark:text-gray-300">I recently had the most magical getaway in the Maldives, and I can confidently say it was an experience of a lifetime! From the moment we arrived, we were greeted with warm hospitality, crystal-clear waters, and breathtaking island scenery.</p>
            </div>
            <div class="flex flex-col">
                <!-- <img src="https://randomuser.me/api/portraits/men/90.jpg" alt="Ash Doe" class="h-10 w-10"> -->
                <p class="pt-2 text-sm font-semibold">Jackson Family</p>
                <!-- <p class="text-sm font-medium text-slate-700/70 dark:text-gray-400">COO at XYZ Corporation</p> -->
            </div>
        </fuse-card>
    </div>
</section>